import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import _ from "lodash";
import { adminRoles, distributorRoles } from "../../../utils/constants";
const ProtectedRouteDistributor = ({ permission, children }) => {
  const { access_token, role } = useSelector((state) => state.AUTH);
  const permissions = useSelector(
    (state) => state?.LOGIN?.LoginData?.data?.permissions || []
  );

  const isAllowed =
    _.some(permission, (permission) => permissions.includes(permission)) &&
    distributorRoles.includes(role);
  if (!access_token) {
    return <Navigate to="/login" />;
  }
  if (isAllowed) {
    return children;
  } else if (!isAllowed && adminRoles.includes(role)) {
    return <Navigate to="/distributor" />;
  } else {
    return <Navigate to="/" />;
  }
};

export default ProtectedRouteDistributor;
